import { jsxs as e, Fragment as l, jsx as C } from "react/jsx-runtime";
const o = () => /* @__PURE__ */ e(l, { children: [
  /* @__PURE__ */ C(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.2398 1.36042C13.6074 1.16947 14.0602 1.31265 14.2511 1.68023C14.5404 2.23712 14.7167 2.77734 14.6487 3.36199C14.6085 3.70841 14.4869 4.02579 14.3204 4.32947C15.3271 4.71207 16.1422 5.48839 16.6999 6.45707C17.4204 7.7084 17.7416 9.32042 17.5371 11.0008C17.4821 11.4523 17.582 11.9245 17.8158 12.3382C18.525 13.5929 18.8539 15.0783 18.6665 16.6177C18.2002 20.4495 14.7159 23.1776 10.8841 22.7113C7.05237 22.2449 4.32419 18.7606 4.79055 14.9289C5.0258 12.996 6.03004 11.343 7.45754 10.2409C7.60049 10.1305 7.6904 9.9713 7.71066 9.80481C7.91518 8.12442 8.61373 6.63652 9.61328 5.59454C10.4515 4.72079 11.5287 4.13861 12.7025 4.0764C12.713 4.05893 12.7242 4.04175 12.7363 4.02489C13.0445 3.59402 13.1385 3.36315 13.1588 3.18893C13.177 3.03209 13.1475 2.80957 12.92 2.37172C12.729 2.00414 12.8722 1.55137 13.2398 1.36042ZM11.9128 12.475C10.0939 12.475 8.37708 13.7279 8.37708 15.5465C8.37708 17.365 10.0939 18.6179 11.9128 18.6179C13.7317 18.6179 15.4485 17.365 15.4485 15.5465C15.4485 13.7279 13.7317 12.475 11.9128 12.475Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C("ellipse", { cx: "12", cy: "16.5", rx: "2", ry: "1.5", fill: "currentColor" })
] });
export {
  o as default
};
